// src/components/store/sections/newsletter/NewsletterV30CyberconsoleIndigoPulse.tsx
"use client";

import React from "react";
import DynamicNewsletterVariant from "./DynamicNewsletterVariant";

export default function NewsletterV30CyberconsoleIndigoPulse(props: any) {
  return (
    <DynamicNewsletterVariant
      variantNumber={30}
      archKey="cyber_console"
      archLabel="Cyber Neon Console"
      palName="IndigoPulse"
      grad="from-indigo-500 via-blue-600 to-violet-700"
      lightBg="bg-indigo-50"
      textCol="text-indigo-700"
      borderCol="border-indigo-200"
      btnCls="bg-indigo-600 hover:bg-indigo-700"
      hexCol="#6366f1"
      {...props}
    />
  );
}
